import React from 'react';
import { dummmyData } from './dummyData';
import { CheckboxGroup, CustomAnchor } from '../../../components';
import PageLayout from '../../../common/layout/PageLayout';

const ManageDocs = () => {

    
    return ( 
        <PageLayout>
                <div className='manageDocs'>
                    <div className='manageDocs-header'>
                            <CustomAnchor href={"/docs"}><img className={'back-icon'} alt="back" src={'/images/icon/prev.svg'}/>Back to the AI page</CustomAnchor>
                    </div>
                    <CheckboxGroup enableSelectAll={true} selectAllLabel={'Select/Unselect All Docs'} options={dummmyData}/>
                </div>
        </PageLayout>
     );
}
 
export default ManageDocs;

